import { useQuery } from '@tanstack/react-query';
import { subscriptionPlanOptionsService } from '@/services/provider/subscription-plan-options.service';

export const subscriptionPlanOptionsKeys = {
  all: ['provider', 'subscription-plan-options'] as const,
  list: (params?: { productId?: string; customerId?: string }) => [
    ...subscriptionPlanOptionsKeys.all,
    params?.productId ?? 'all',
    params?.customerId ?? 'all',
  ] as const,
};

export function useSubscriptionPlanOptions(
  params?: { productId?: string; customerId?: string },
  enabled = true,
) {
  return useQuery({
    queryKey: subscriptionPlanOptionsKeys.list(params),
    queryFn: () => subscriptionPlanOptionsService.list(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
